// import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
// import { CommonModule } from '@angular/common';

// @Component({
//   selector: 'app-avantor-tab-blocker',
//   templateUrl: './avantor-tab-blocker.html',
//   styleUrls: ['./avantor-tab-blocker.scss']
// })
// export class AvantorTabBlockerComponent implements OnInit, OnDestroy {
//   isTabActive: boolean = true;
//   private tabId: string = this.generateTabId(); // Unique ID for this tab
//   private baseUrl: string = this.extractBaseUrl(window.location.href); // Base URL of the current tab

//   constructor(private cdr: ChangeDetectorRef) {
//     this.initializeTabControl();
//   }

//   ngOnInit() { }

//   ngOnDestroy(): void {
//     this.cleanUpTabControl();
//   }

//   private initializeTabControl() {
//     if (window.location.href.includes('/admin/') && sessionStorage.getItem('isAdminConsole') === 'Yes') {
//       this.isTabActive = true;
//       return; // Skip the blocking logic entirely
//     }
//     if (this.isDuplicateTab(this.baseUrl)) {
//       this.isTabActive = false; // Block duplicate tab
//       return;
//     }

//     // Register the current base URL in localStorage
//     localStorage.setItem(`activeTab_${this.baseUrl}`, this.tabId);

//     window.addEventListener('beforeunload', this.onBeforeUnload.bind(this));
//   }

//   private isDuplicateTab(baseUrl: string): boolean {
//     // Check if the base URL is already in localStorage
//     const existingTabId = localStorage.getItem(`activeTab_${baseUrl}`);

//     // If a tab with the same base URL exists, it's a duplicate
//     return !!existingTabId && existingTabId !== this.tabId;
//   }

//   private extractBaseUrl(fullUrl: string): string {
//     // Extract the protocol and hostname (base URL)
//     const url = new URL(fullUrl);
//     return `${url.protocol}//${url.hostname}`;
//   }

//   private cleanUpTabControl() {
//     // Remove the current base URL from localStorage
//     localStorage.removeItem(`activeTab_${this.baseUrl}`);
//     window.removeEventListener('beforeunload', this.onBeforeUnload.bind(this));
//   }

//   private onBeforeUnload(event: BeforeUnloadEvent) {
//     this.cleanUpTabControl();
//   }

//   private generateTabId(): string {
//     return Math.random().toString(36).substr(2, 9); // Generate a unique identifier for this tab
//   }
// }


import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { FormsModule } from '@angular/forms';
import { MaterialsModule } from '@shared/materials.module';

@Component({
  selector: 'app-avantor-tab-blocker',
  templateUrl: './avantor-tab-blocker.html',
  styleUrls: ['./avantor-tab-blocker.scss'],
  standalone: true,
  imports: [CommonModule, SharedModule, FormsModule, MaterialsModule],
})
export class AvantorTabBlockerComponent implements OnInit, OnDestroy {
  isTabActive: boolean = true;
  private tabId: string = this.generateTabId();
  private channel: BroadcastChannel = new BroadcastChannel('tab_control');
  private static activeTabs: Set<string> = new Set(); // Track open tabs
  private static firstTabId: string | null = null;

  constructor(private cdr: ChangeDetectorRef) {
    this.initializeTabControl();
  }

  ngOnInit() { }

  ngOnDestroy(): void {
    this.cleanUpTabControl();
  }

  private initializeTabControl() {
    // Skip the blocking logic if in the admin console
    if (window.location.href.includes('/admin/') && sessionStorage.getItem('isAdminConsole') === 'Yes') {
      this.isTabActive = true;
      return;
    }

    this.channel.postMessage({ type: 'hello', tabId: this.tabId });

    const handleMessage = (event: MessageEvent) => {
      const { type, tabId } = event.data;

      if (type === 'hello') {
        AvantorTabBlockerComponent.activeTabs.add(tabId);

        if (!AvantorTabBlockerComponent.firstTabId) {
          AvantorTabBlockerComponent.firstTabId = tabId;
          this.isTabActive = true;
        } else if (AvantorTabBlockerComponent.firstTabId !== tabId) {
          this.channel.postMessage({ type: 'block', tabId: tabId });
        }
      }

      if (type === 'block' && tabId === this.tabId) {
        this.isTabActive = false;
        this.cdr.detectChanges();
      }

      if (type === 'close' && tabId === AvantorTabBlockerComponent.firstTabId) {
        AvantorTabBlockerComponent.activeTabs.delete(tabId);

        if (AvantorTabBlockerComponent.activeTabs.size > 0) {
          // const nextTab = AvantorTabBlockerComponent.activeTabs.values().next().value;
          // AvantorTabBlockerComponent.firstTabId = nextTab;
          const nextTab = AvantorTabBlockerComponent.activeTabs.values().next().value;
          AvantorTabBlockerComponent.firstTabId = nextTab ?? null;
          this.channel.postMessage({ type: 'activate', tabId: nextTab });
        } else {
          AvantorTabBlockerComponent.firstTabId = null;
        }
      }

      if (type === 'activate' && tabId === this.tabId) {
        this.isTabActive = true;
        this.cdr.detectChanges();
      }
    };

    this.channel.addEventListener('message', handleMessage);

    setTimeout(() => {
      if (!AvantorTabBlockerComponent.firstTabId) {
        AvantorTabBlockerComponent.firstTabId = this.tabId;
      } else if (AvantorTabBlockerComponent.firstTabId !== this.tabId) {
        this.isTabActive = false;
      }
      this.cdr.detectChanges();
    }, 300);
  }

  private cleanUpTabControl() {
    this.channel.postMessage({ type: 'close', tabId: this.tabId });
    this.channel.close();
  }

  private generateTabId(): string {
    return Math.random().toString(36).substr(2, 9);
  }
}
